import React, { ComponentProps } from 'react'

type SendIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function SendIcon(props: SendIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <g clipPath="url(#clip0_22211_14622)">
        <path
          d="M9.6907 14.4577C9.71603 14.5208 9.76006 14.5747 9.81688 14.6121C9.87371 14.6494 9.9406 14.6685 10.0086 14.6668C10.0766 14.665 10.1424 14.6426 10.1973 14.6023C10.2521 14.5621 10.2933 14.506 10.3154 14.4417L14.6487 1.77503C14.67 1.71596 14.6741 1.65203 14.6604 1.59073C14.6468 1.52943 14.6159 1.47329 14.5715 1.42888C14.5271 1.38447 14.471 1.35363 14.4097 1.33996C14.3484 1.32629 14.2844 1.33036 14.2254 1.3517L1.5587 5.68503C1.49436 5.70709 1.43832 5.74831 1.39808 5.80314C1.35785 5.85798 1.33535 5.92381 1.33361 5.9918C1.33186 6.05979 1.35096 6.12669 1.38834 6.18351C1.42571 6.24034 1.47958 6.28437 1.5427 6.3097L6.82937 8.4297C6.99649 8.49661 7.14833 8.59667 7.27574 8.72385C7.40315 8.85103 7.50349 9.00269 7.5707 9.1697L9.6907 14.4577Z"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5692 1.43164L7.27588 8.72431"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_22211_14622">
          <rect width="16" height="16" fill="none" />
        </clipPath>
      </defs>
    </svg>
  )
}
